import { createContext } from 'react'
import type { PendingStoreKiosk } from '@gozoki/api-types'

export interface ClientEntryContextType {
  pendingKiosks: PendingStoreKiosk[]
  askEntry: (pendingKiosk: PendingStoreKiosk) => void
  openClientForPendingKiosk: (kioskId: number, openPage: boolean) => void
}

export const ClientEntryContext = createContext<ClientEntryContextType>({
  askEntry: () => {},

  openClientForPendingKiosk: () => {},

  pendingKiosks: [],
})
